import { useQuery } from "@tanstack/react-query";
import { getNewSeasonComponent } from "./NewSeasonComponentApi";

export const useNewSeasonComponent = () => {
  return useQuery({
    queryKey: ["new-season-component"],
    queryFn: ({ signal }) => getNewSeasonComponent(signal),
  });
};
